import $ from 'jquery';
import { gsap, TweenMax, Power1, Power3 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CSSRulePlugin } from 'gsap/CSSRulePlugin';
import Scrollbar from 'smooth-scrollbar';
import OverscrollPlugin from 'smooth-scrollbar/plugins/overscroll';
import { HorizontalScrollPlugin } from '../modules/HorizontalScrollPlugin';
require('intersection-observer');

if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(CSSRulePlugin);
    gsap.core.globals("ScrollTrigger", ScrollTrigger);
}

export default function() {
    let scrollbar;
    let option = {
        x: 0,
        speed: 1.5,
        limit: 2,
        time: 0.3,
    };

    function init() {
        let horizontalScroll = initHorizontalScroll();

        $('.bottomArea .searchToggle').on('click', function(e){
            e.preventDefault();
            $(this).parent().addClass('active');
        });

        if (document.querySelector('.slide2 .carousel')) {
          var carousel = document.querySelectorAll('.slide2 .carousel img');
          // Should be 1 - x, not 0, which is the sentry
          var r = Math.ceil(Math.random() * (carousel.length - 1));
          carousel[r].classList.add('visible');
          setInterval(function() {
            document.querySelector('.slide2 .carousel img.visible').classList.remove('visible');
            r = Math.ceil(Math.random() * (carousel.length - 1));
            carousel[r].classList.add('visible');
          }, 3000);
        }


        if(window.innerWidth <= 1024) {
            dispose();
        } else {
            const initAnimateTexts = document.querySelectorAll('.js-texts-trigger-init');
            initAnimateTexts.forEach((elem, i) => {
                gsap.fromTo(elem, { opacity: 0, y: '50%' }, { delay: 1.1 * i, duration: 0.9, opacity: 1, y: '0%' });
            });

            const animateTexts = document.querySelectorAll('.js-texts-trigger');
            animateTexts.forEach((elem) => {
                gsap.set(elem, { opacity: 0, y: '50%' });
            });
        }

        window.addEventListener('resize', () => {
            if(window.innerWidth <= 1024) {
                dispose();
            } else {
                horizontalScroll = initHorizontalScroll();
            }
        });

        window.addEventListener('keydown', (e) => {
          //console.log(e.key, e.keyCode, scrollbar.offset.x);
          // ArrowUp
          // ArrowDown
          // ArrowRight
          // ArrowLeft
          if (e.key == 'ArrowRight' || e.key == 'ArrowDown') {
            scrollbar.scrollTo(scrollbar.offset.x + 200, 0, 300);
          } else if (e.key == 'ArrowLeft' || e.key == 'ArrowUp') {
            scrollbar.scrollTo((scrollbar.offset.x - 200 > 0 ? scrollbar.offset.x - 200 : 0), 0, 300);
          }
        });

    }

    function initHorizontalScroll() {
        Scrollbar.use(HorizontalScrollPlugin, OverscrollPlugin);
        scrollbar = Scrollbar.init(document.querySelector('#scrollView'), {
            overscrollEffect: 'bounce',
            alwaysShowTracks: false
        });

        const listener = (status) => {
            // console.log('scrollbar', status.offset.x);

            // Always update
            option.x = status.offset.x;
            document.querySelector('.slide1 .slide__container').style.transform = 'translate3d(' + Math.floor(option.x / 4) + 'px,0,0)';

            const header = document.querySelector('header');
            const headerContainer = header.querySelector('.container');
            if(status.offset.x > 80) {
                header.classList.add('responsive');
            } else {
                header.classList.remove('responsive');
            }

            let slide1, slide2, slide3, slide4, slide5;
            const menuLogo = document.querySelector('.logo');
            const mobileMenuTrigger = document.querySelector('.res-menu-trigger');

            const logoOffset = headerContainer.getBoundingClientRect().width - menuLogo.getBoundingClientRect().width;

            const animateImageOffset = window.outerWidth - 300;
            const animateImages = document.querySelectorAll('.js-image-trigger');
            animateImages.forEach((elem) => {
                let targetPosition = elem.getBoundingClientRect().left - animateImageOffset;
                if(targetPosition <= 0) {
                    var p = (animateImageOffset - elem.getBoundingClientRect().left) / elem.getBoundingClientRect().width * 105;
                    if (p > 100) p = 100;
                    p = 100 - p;
                    elem.querySelector('.mask').style.width = p + '%';
                    elem.querySelector('.mask').style.opacity = p / 100;
                } else {
                    elem.querySelector('.mask').style.width = '100%';

                }
                if(targetPosition <= 0 && !elem.classList.contains('active')) {
                    elem.classList.add('active');
                }
            });

            const animateTextOffset = window.outerWidth;// - 100;
            const animateTexts = document.querySelectorAll('.js-texts-trigger');
            const halfWidth = (window.outerWidth / 2);
            animateTexts.forEach((elem, i) => {
                let targetPosition = elem.getBoundingClientRect().left - animateTextOffset;
                if (elem.classList.contains('lastframe')) {
                  targetPosition -= 100;
                }
                if(targetPosition <= 0) {
                  // Special case on the last frame:
                  if (elem.classList.contains('lastframe')) {
                    if (!elem.classList.contains('active')) {
                      elem.classList.add('active');
                      gsap.to(elem, { delay: 0.5, duration: 1, opacity: 1, y: '0%', ease: Power1.easeInOut  });
                    }
                  } else {
                      var y = 50 * (elem.getBoundingClientRect().left - halfWidth) / halfWidth;
                      if (y < 0) y = 0;
                      if (y > 50) y = 50;
                      var x = y / 15;
                      elem.style.transform = 'translate3D(' + x + 'em,' + y + '%,0)';
                      elem.style.opacity = (50 - y) / 50;

                  }
                }
            });

            const targets = document.querySelectorAll('.slide');
            targets.forEach((target, i) => {
                $('.slide' + i + 'Logo').css({left: target.getBoundingClientRect().x + 'px', width: target.getBoundingClientRect().width});
                const targetWidth = target.getBoundingClientRect().width;

                if(target.classList.contains('slide1')) {
                    slide1 = targetWidth;

                    if(status.offset.x < (targetWidth) && status.offset.x < (targetWidth + logoOffset) ) {
                        menuLogo.classList.remove('dark');
                        menuLogo.classList.remove('light2');
                    }
                }

                if(target.classList.contains('slide2')) {
                    slide2 = targetWidth;

                    if(status.offset.x > 30 && status.offset.x < targetWidth ) {
                        mobileMenuTrigger.classList.add('dark');
                    }

                    if(status.offset.x > (30 + logoOffset) && status.offset.x < (targetWidth + logoOffset) ) {
                        menuLogo.classList.add('dark');
                        menuLogo.classList.remove('light2');
                    }
                }

                if(target.classList.contains('slide3')) {
                    slide3 = targetWidth;

                    if(
                        status.offset.x > slide2
                        && status.offset.x < (slide2 + slide3)
                    ) {
                        mobileMenuTrigger.classList.remove('dark');
                    }

                    if(
                        status.offset.x > (slide2 + logoOffset)
                        && status.offset.x < (slide2 + slide3 + logoOffset)
                    ) {
                        menuLogo.classList.remove('dark');
                        menuLogo.classList.add('light2');
                    }
                }

                if(target.classList.contains('slide4')) {
                    slide4 = targetWidth;

                    if(
                        status.offset.x > (slide2 + slide3)
                        && status.offset.x < (slide2 + slide3 + slide4)
                    ) {
                        mobileMenuTrigger.classList.add('dark');
                    }

                    if(
                        status.offset.x > (slide2 + slide3 + logoOffset)
                        && status.offset.x < (slide2 + slide3 + slide4 + logoOffset)
                    ) {
                        menuLogo.classList.add('dark');
                        menuLogo.classList.remove('light2');
                    }
                }

                if(target.classList.contains('slide5')) {
                    slide5 = targetWidth;

                    if(
                        status.offset.x > (slide2 + slide3 + slide4)
                        && status.offset.x < (slide2 + slide3 + slide4 + slide5)
                    ) {
                        mobileMenuTrigger.classList.remove('dark');
                    }

                    if(
                        status.offset.x > (slide2 + slide3 + slide4 + logoOffset)
                        && status.offset.x < (slide2 + slide3 + slide4 + slide5 + logoOffset)
                    ) {
                        menuLogo.classList.remove('dark');
                        menuLogo.classList.add('light2');
                    }
                }
            });

        }
        scrollbar.addListener(listener);

        // Animation
        const firstSlideLink = document.querySelector('.slide1 .nextLink');
        firstSlideLink.addEventListener('click', (e) => scrollBarTransition(e), false);
    }

    function scrollBarTransition(e) {
        e.preventDefault();

        TweenMax.to(option, 1.4, {
            x: window.innerWidth,
            ease: Power3.easeOut,
            onUpdate: () => {
              scrollbar.scrollTo(option.x, 0, 0);
            }
        });
    }

    function dispose() {
        Scrollbar.destroyAll();

        document.querySelector('.slide1 .slide__container').removeAttribute('style');
        const firstSlideLink = document.querySelector('.slide1 .nextLink');
        firstSlideLink.removeEventListener('click', (e) => scrollBarTransition(e));

        const initAnimateTexts = document.querySelectorAll('.js-texts-trigger-init');
        initAnimateTexts.forEach((elem, i) => {
            elem.removeAttribute('style');
        });

        const animateTexts = document.querySelectorAll('.js-texts-trigger');
        animateTexts.forEach((elem) => {
            elem.removeAttribute('style');
        });
    }

    if(document.querySelector('.home')) {
        init();
    }
}
